import { render, staticRenderFns } from "./CoachDetail.vue?vue&type=template&id=aa6bf1ee&scoped=true"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachDetail.vue?vue&type=style&index=0&id=aa6bf1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6bf1ee",
  null
  
)

export default component.exports